// One document per caregiver per week (Sunday to Saturday)
export interface CgWeekReportStatus {
  cgId: string; // caregiver id
  cgName: string; // caregiver name
  year: number; // e.g., 2025
  weekNumber: number; // Week number using DateUtil.getWeekNumber (Sun-Sat)
  weekStartDate: string; // YYYY-MM-DD for Sunday (to avoid TZ ambiguity)
  weekEndDate: string; // YYYY-MM-DD for Saturday
  sentAt?: Date; // when the report was sent (undefined if not sent yet)
  appointmentsCount: number; // number of appointments included in the report
  lastUpdatedAt?: Date; // tracking updates for re-sends
  details: CgWeekReportStatusDetail[]; // details of the week report
  status: CgWeekReportStatusEnum;
  sentToQuickBooks?: boolean;
  quickBooksId?: string;
  sentToQuickBooksAt?: Date;
}

export enum CgWeekReportStatusEnum {
  PENDING = 'CgWeekReportStatusEnum.PENDING',
  APPROVED = 'CgWeekReportStatusEnum.APPROVED',
  REJECTED = 'CgWeekReportStatusEnum.REJECTED',
}

export interface CgWeekReportStatusDetail {
  patientName: string;
  sunday: number;
  monday: number;
  tuesday: number;
  wednesday: number;
  thursday: number;
  friday: number;
  saturday: number;
  total: number;
}
